import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import {
  catchError,
  map,
  skip, take
} from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import {
  BaseHTTPService,
  HandleErrorOptions
} from '@sondermind/http';
import { ProviderNetworkCompany } from '@sondermind/utilities/models-client-facing';
import {
  HTTP_ERROR_HANDLER,
  IHttpErrorHandler
} from '@sondermind/utilities/models-http';

const payersSort = (a: ProviderNetworkCompany, b: ProviderNetworkCompany) => a.name.localeCompare(b.name);

@Injectable({
  providedIn: 'root'
})
export class PayerDataService extends BaseHTTPService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpClient,
    @Optional()
    @Inject(HTTP_ERROR_HANDLER)
    httpErr: IHttpErrorHandler[]
  ) {
    super(httpErr);
  }

  private store = new BehaviorSubject<ProviderNetworkCompany[]>([]);
  store$ = this.store.asObservable();

  refresh(): Observable<ProviderNetworkCompany[]> {
    this.fetch().subscribe((as) => this.store.next(as));
    return this.store$
      .pipe(
        map((pn) => pn.sort(payersSort))
      )
      .pipe(skip(1), take(1));
  }

  fetch(opts: Partial<HandleErrorOptions> = {}): Observable<ProviderNetworkCompany[]> {
    const url = `${this.configurationService.env.apiBase}/v2/payers`;
    return this.http
      .get<{ providerNetworkCompanies: ProviderNetworkCompany[]; }>(url)
      .pipe(
        map((p) => p.providerNetworkCompanies),
        catchError(this.handleError.bind(this, opts))
      );
  }
}
